import { Component, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { switchMap, finalize } from 'rxjs/operators';
import { WorkflowContextService } from '../../../../../services';

@Component({
  selector: 'app-contractors-janus-renew',
  templateUrl: './contractors-janus-renew.component.html',
  styleUrls: ['./contractors-janus-renew.component.scss'],
  standalone: false
})
export class ContractorsJanusRenewComponent implements OnInit {
  @Input() row!: any;
  @Input() contractorTypeId!: string;
  @Input() closeExpansion!: () => void;

  isLoading = false;
  navigateToStepperForm = false;

  applicationId!: string;
  activityDataId!: string;
  workflowId!: string;
  workflowVersionId!: string;
  isTestApplication!: boolean;

  constructor(
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private _contextSvc: WorkflowContextService
  ) {}

  ngOnInit(): void {
    if (!this.row?.id) {
      console.error('Registration ID missing');
      return;
    }

    this.startRenewFlow();
  }

  private startRenewFlow(): void {
     this._contextSvc.applicationReturnURL = this.router.url;
    this.isLoading = true;

    this.dataService
      .startContractorRegistrationRenewal(
        this.row.id,
        this.contractorTypeId,
        false
      )
      .pipe(
        switchMap((startRes: any) => {
          this.applicationId = startRes.applicationId;
          return this.dataService.isWorkflowApplicationInProgress(this.applicationId);
        }),
        switchMap(() => {
          return this.dataService.getCurrentApplicationActivity(this.applicationId);
        }),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: (response: any) => {
          let activityDataId: string | undefined;

          if (response.activity?.activityDataId) {
            activityDataId = response.activity.activityDataId;
          } else {
            const formActivity = response.navigationActivities?.find(
              (a: any) => a.activityType === 'form-activity'
            );

            if (!formActivity) {
              console.error('No form activity found');
              return;
            }

            activityDataId = formActivity.activityDataId;
          }

          if (!activityDataId) return;

          this.activityDataId = activityDataId;
          this.workflowId = response.workflowId;
          this.workflowVersionId = response.workflowVersionId;
          this.isTestApplication = response.isTestApplication;

          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              id: this.applicationId,
              activityDataId: this.activityDataId,
              workflowId: this.workflowId,
              workflowVersionId: this.workflowVersionId,
              isTest: this.isTestApplication,
              showAppView: 1
            },
            queryParamsHandling: 'merge'
          });

          this.navigateToStepperForm = true;
        },
        error: err => {
          console.error('Renew flow failed:', err);
        }
      });
  }
}